/**
 * @class
 * @function ShippingCountdown
 *
 * Custom element that counts down to today's shipping cutoff hour.
 * Reads per-day cutoff hours from data attributes (data-cutoff-mon … data-cutoff-sun).
 * If the cutoff has passed (or is 0), the timer row is hidden until 00:01 next day.
 */
if (!customElements.get('shipping-countdown')) {
  class ShippingCountdown extends HTMLElement {
    constructor() {
      super();
      this.cutoffs = {
        1: parseInt(this.dataset.cutoffMon) || 0, // Monday
        2: parseInt(this.dataset.cutoffTue) || 0,
        3: parseInt(this.dataset.cutoffWed) || 0,
        4: parseInt(this.dataset.cutoffThu) || 0,
        5: parseInt(this.dataset.cutoffFri) || 0,
        6: parseInt(this.dataset.cutoffSat) || 0,
        0: parseInt(this.dataset.cutoffSun) || 0  // Sunday = 0 in JS
      };
    }

    connectedCallback() {
      this.hoursEl = this.querySelector('.shipping-countdown__hours');
      this.minutesEl = this.querySelector('.shipping-countdown__minutes');
      this.secondsEl = this.querySelector('.shipping-countdown__seconds');
      this.timerRow = this.closest('.shipping-countdown__body')?.querySelector('.shipping-countdown__timer-row');

      if (!this.hoursEl || !this.minutesEl || !this.secondsEl) return;

      this.tick();
      this.interval = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.interval) clearInterval(this.interval);
      if (this.wakeTimeout) clearTimeout(this.wakeTimeout);
    }

    hideTimerRow() {
      if (this.timerRow) this.timerRow.style.display = 'none';
      if (this.interval) {
        clearInterval(this.interval);
        this.interval = null;
      }
      this.scheduleWake();
    }

    showTimerRow() {
      if (this.timerRow) this.timerRow.style.display = '';
      if (!this.interval) {
        this.interval = setInterval(() => this.tick(), 1000);
      }
    }

    scheduleWake() {
      const now = new Date();
      const tomorrow = new Date(now);
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(0, 1, 0, 0); // 00:01 next day
      const ms = tomorrow - now;
      this.wakeTimeout = setTimeout(() => {
        this.showTimerRow();
        this.tick();
      }, ms);
    }

    tick() {
      const now = new Date();
      const day = now.getDay();
      const cutoffHour = this.cutoffs[day] || 0;

      if (cutoffHour <= 0) {
        this.hideTimerRow();
        return;
      }

      const cutoff = new Date(now);
      cutoff.setHours(cutoffHour, 0, 0, 0);

      const distance = cutoff - now;

      if (distance <= 0) {
        this.hideTimerRow();
        return;
      }

      const hours = Math.floor(distance / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      this.hoursEl.textContent = ShippingCountdown.pad(hours);
      this.minutesEl.textContent = ShippingCountdown.pad(minutes);
      this.secondsEl.textContent = ShippingCountdown.pad(seconds);
    }

    static pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }
  }

  customElements.define('shipping-countdown', ShippingCountdown);
}
